<template>
  <div class="coupon-list-popup">
    <div class="coupon-list-popup-shade"></div>
    <div class="coupon-list-popup-content">
      <p class="coupon-list-popup-title">{{ letter.couponSelect }}</p>
      <div
        class="coupon-list-popup-content-scroll"
        :class="{ 'full-height': popupType != 'paytype' }"
      >
        <div class="coupon-list-popup-type">
          <span class="coupon-list-popup-name">
            {{ letter.couponCanUse
            }}<span class="coupon-list-popup-type-total"
              >({{ enableCouponList.length }})</span
            >
          </span>
          <span class="coupon-list-popup-type-tip">{{
            letter.couponUseTip
          }}</span>
        </div>
        <template v-if="enableCouponList.length">
          <coupon-item
            v-for="item in enableCouponList"
            :key="item.COUPON_ID"
            :info="item"
            :active="item.COUPON_ID == activeCouponId"
            :showItemUseBtn="showItemUseBtn"
            @chooseCoupon="chooseCoupon"
            @closePopup="hidePopup"
          ></coupon-item>
        </template>
        <template v-else>
          <coupon-item :isEmpty="true"></coupon-item>
        </template>

        <div class="coupon-list-popup-type">
          <span class="coupon-list-popup-name">
            {{ letter.couponCanNotUse
            }}<span class="coupon-list-popup-type-total"
              >({{ invalidCouponTotal }})</span
            >
          </span>
        </div>
        <template v-if="invalidCouponTotal > 0">
          <coupon-item
            v-for="item in disableCouponList"
            :key="item.COUPON_ID"
            :info="item"
            :invalid="true"
          ></coupon-item>
          <coupon-item
            v-for="item in expireCouponList"
            :key="item.COUPON_ID"
            :info="item"
            :invalid="true"
          ></coupon-item>
        </template>
        <template v-else>
          <coupon-item :isEmpty="true" :invalid="true"></coupon-item>
        </template>
      </div>
      <div
        class="coupon-list-popup-use j-click-coupon-use"
        :pointValue="activeCouponId"
        v-if="popupType == 'paytype'"
        @click="updateActiveCouponId"
      >
        {{ letter.couponSureUse }}
      </div>
      <a
        class="coupon-list-popup-close j-click-coupon-close"
        href="javascript:;"
        @click="hidePopup"
      ></a>
    </div>
  </div>
</template>

<script type="text/javascript">
import CouponItem from '@components/officialStore/coupon/CouponItem.vue';
import { UPDATE_PAYTYPE_ACTIVE_COUPON_ID } from '@store/officialStore/coupon';
export default {
  name: 'couponListPopup',
  props: [
    'enableCouponList',
    'disableCouponList',
    'expireCouponList',
    'activeId',
    'showItemUseBtn',
    'popupType'
  ],
  data() {
    return {
      activeCouponId: '',
      acticeCouponInfo: ''
    };
  },
  computed: {
    invalidCouponTotal() {
      return this.disableCouponList.length + this.expireCouponList.length;
    },
    letter() {
      return this.$store.state.letter;
    }
  },
  created() {
    if (this.popupType == 'paytype') {
      if (this.activeId) {
        this.activeCouponId = this.activeId;
      } else {
        this.autoSelectFirstCoupon();
      }
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closeCouponPopup');
    },
    chooseCoupon(couponInfo) {
      this.acticeCouponInfo = couponInfo;
      if (this.popupType == 'game') {
        return;
      }
      if (this.activeCouponId == couponInfo.COUPON_ID) {
        this.activeCouponId = '';
      } else {
        this.activeCouponId = couponInfo.COUPON_ID;
      }
    },
    updateActiveCouponId() {
      if (this.activeCouponId) {
        window.webstorev1DataLayer.push({
          eventName: 'select_coupon',
          eventReason: 'click_select',
          eventType: 'choose',
          eventValue: {
            coupon_typeid: this.acticeCouponInfo?.COUPON_TYPE || '',
            coupon_type_name: this.acticeCouponInfo?.tagText || '',
            coupon_id: this.acticeCouponInfo?.COUPON_ID || '',
            coupon_start_time: this.acticeCouponInfo?.GET_TIME || '',
            coupon_end_time: this.acticeCouponInfo?.EXPIRY_TIME || '',
            coupon_local_money: this.acticeCouponInfo?.fullReductMoney || '',
            coupon_discount: this.acticeCouponInfo?.DISCOUNT || ''
          }
        });
      } else {
        window.webstorev1DataLayer.push({
          eventName: 'select_coupon',
          eventReason: 'click_select',
          eventType: 'cancel',
          eventValue: {
            coupon_typeid: '',
            coupon_type_name: '',
            coupon_id: '',
            coupon_start_time: '',
            coupon_end_time: '',
            coupon_local_money: '',
            coupon_discount: ''
          }
        });
      }

      this.$store.commit(UPDATE_PAYTYPE_ACTIVE_COUPON_ID, this.activeCouponId);
      this.hidePopup();
    },
    autoSelectFirstCoupon() {
      if (this.enableCouponList && this.enableCouponList.length) {
        this.activeCouponId = this.enableCouponList[0].COUPON_ID;
      }
    }
  },
  components: {
    CouponItem
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.coupon-list-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    padding: 37px 47px 150px;
    width: 691px;
    height: 90%;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('coupon-popup-bg.png', false, false);
    &-scroll {
      overflow: -moz-scrollbars-none;
      overflow-y: scroll;
      position: relative;
      max-height: 90%;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
      }
    }
    .full-height {
      max-height: 100% !important;
    }
  }
  &-title {
    margin-bottom: 39px;
    text-align: center;
    font-size: 48px;
    color: var(--coupon-popup-title);
  }
  &-type {
    display: flex;
    justify-content: space-between;
    margin-top: 54px;
    margin-bottom: 17px;
    font-size: 28px;
    color: var(--coupon-popup-type-title);
    &:nth-child(1) {
      margin-top: 0;
    }
    &-tip {
      font-size: 20px;
      color: var(--coupon-popup-tip);
    }
  }
  &-use {
    display: flex;
    position: absolute;
    left: 50%;
    bottom: 66px;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    color: var(--coupon-popup-use-btn);
    transform: translateX(-50%);
    @psetbg ('coupon-popup-item-use.png');
  }
  &-close {
    position: absolute;
    right: 31px;
    top: 30px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('close.png');
  }
}
@media screen and (orientation: landscape) {
  .coupon-list-popup {
    &-content {
      padding: 25px 32px 150px;
      width: 444px;
      height: 90%;
      background-size: 100% 100%;
    }
    &-title {
      font-size: 30px;
    }
    &-type {
      margin-top: 38px;
      margin-bottom: 12px;
      font-size: 18px;
      &-tip {
        font-size: 14px;
      }
    }
    &-use {
      font-size: 23px;
      @psetbg ('coupon-popup-item-use-hen.png');
    }
    &-close {
      // 这里
      position: absolute;
      @psetbg ('close-hen.png');
    }
  }
}
</style>
